(() => {
  const triggerSelector = '[data-hover-image-trigger]';
  const imageSelector = 'img[data-deferred-hover-image]';
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const hydrateImage = (image) => {
    if (!image || !image.hasAttribute('data-deferred-hover-image')) return;

    const markLoaded = () => image.classList.add('is-loaded');
    image.addEventListener('load', markLoaded, { once: true });

    if (image.dataset.sizes) image.sizes = image.dataset.sizes;
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;

    image.removeAttribute('data-deferred-hover-image');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-sizes');

    if (image.complete && image.naturalWidth > 0) markLoaded();
  };

  const hydrateImages = (trigger) => {
    trigger.querySelectorAll(imageSelector).forEach(hydrateImage);
  };

  const bindTriggers = (root = document) => {
    root.querySelectorAll(triggerSelector).forEach((trigger) => {
      if (trigger.dataset.hoverImageBound === 'true') return;
      trigger.dataset.hoverImageBound = 'true';

      trigger.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch' || !finePointer.matches) return;
        hydrateImages(trigger);
      });
      trigger.addEventListener('focusin', () => hydrateImages(trigger));
    });
  };

  bindTriggers();
  document.addEventListener('shopify:section:load', (event) => bindTriggers(event.target));
})();
